export const formatCurrency = (
  amount,
  forceDecimals = false,
  currency = "INR"
) => {
  // 1. Sanitize input
  const value = isNaN(amount) || amount === null ? 0 : Number(amount);

  // 2. Fallback for currency
  const currencyCode = currency && currency.trim() !== "" ? currency : "INR";

  // 3. Logic: If it's a whole number (e.g., 5) and we aren't forcing decimals,
  // set minimum to 0. Otherwise, use 2 for decimals or forced format.
  const minFraction = forceDecimals || value % 1 !== 0 ? 2 : 0;

  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: minFraction,
    maximumFractionDigits: 2,
  }).format(value);
};
